import React, { useState } from 'react';
import { Button, Modal, Text } from '@fragments';
import { IconArrowRight, IconBrandInstagram } from '@tabler/icons-react';
import { compactCount } from '../../components/AccountSummary';
import './styles.scss';

// The end of the onboarding: the account the profile was built from (its photo
// on the platform, @ and followers) and one way on, to the first prompt. The
// photo is the Studio's signed copy (contract 1.6.0); without one, the initial.
// The same photo, blurred, tints the top of the surface. A profile connected after the
// first (`added`) is greeted as connected rather than as the Studio being ready. With
// Personality on (contract 2.3.0), the way on passes through the personality picker while
// the new profile has none: "Continuar" leads there, where it can be skipped.
export default function ProfileReadyDialog({ studio: s, account, added = false }) {
  const { t, locale, myPersonality } = s;
  const handle = account?.handle || '';
  const picture = account?.picture?.url || null;
  const [broken, setBroken] = useState(false);
  const photo = picture && !broken;
  const followers = account?.followers_count;
  const personalityNext = !!myPersonality?.enabled && myPersonality.record?.status === 'not_configured';
  const close = () => (myPersonality?.enabled ? myPersonality.offer() : s.setModal(null));
  return <Modal open variant="flat" size={360} hideClose onClose={close} aria-labelledby="studio-ready-title" aria-describedby="studio-ready-text" className="studio-dialog studio-ready-dialog"
    backdrop={photo ? <div className="studio-ready__wash"><img src={picture} alt="" /></div> : null}>
    <div className="studio-ready">
      <div className="studio-ready__identity">
        <span className="studio-ready__avatar">
          {photo
            ? <img src={picture} alt="" onError={() => setBroken(true)} />
            : <Text.h3 weight={500} contrast={9} aria-hidden="true">{(account?.name || handle || '@').trim().charAt(0).toUpperCase()}</Text.h3>}
          <span className="studio-ready__platform" aria-hidden="true"><IconBrandInstagram /></span>
        </span>
        <div className="studio-ready__account">
          {handle && <Text.h5 weight={500} contrast={9}>@{handle}</Text.h5>}
          {followers != null && <Text.span contrast={6}>{t('onboardingFollowers', { count: followers, value: compactCount(followers, locale) })}</Text.span>}
        </div>
      </div>
      <div className="studio-ready__message">
        <Text.h4 id="studio-ready-title" weight={500} contrast={9}>{t(added ? 'profileReadyAddedTitle' : 'onboardingReadyTitle')}</Text.h4>
        <Text.p id="studio-ready-text" contrast={7}>{t(personalityNext ? 'onboardingReadyPersonalityText' : 'onboardingReadyText')}</Text.p>
      </div>
      <Button autoFocus variant="rounded" color="inverse" size="large" fullWidth endIcon={<IconArrowRight />} preventLoading onClick={close}>{t(personalityNext ? 'onboardingReadyPersonalityCta' : 'onboardingReadyCta')}</Button>
    </div>
  </Modal>;
}
